const IntegrationTypeEnum = Object.freeze({
    MANUAL: 'MANUAL',
    CITYPARTNERSHIP: 'CITYPARTNERSHIP'
});

export default IntegrationTypeEnum;
